import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionsService } from 'src/app/auth/permissions.service';

const DOCUMENT_VIEW_PERMISSIONS: Record<string, string[]> = {
  invoice: [
    'invoices:view', 'sales:view', 'reportes:view', 'clientes:view', 'panel:view',
    'inventory:view', 'inventory:items:edit', 'inventory:products:view', 'inventory:history:view', 'inventory:no_list:view',
    'inventory:outside_warehouse:view', 'inventory:outside_warehouse:save',
    'visual:sale_reposition:request', 'visual:inventory_labels:manage',
    'inventory:warehouse_labels:manage', 'administracion:facturas_fiscales',
    'administracion:reportes_pagos', 'purchase-v2:requisition:view',
    'purchase-v2:requisition:create', 'purchase-v2:requisition:edit',
  ],
  estimate: [
    'sales:view', 'clientes:view', 'panel:view', 'administracion:reportes_pagos',
  ],
  prestamos: ['prestamos:view', 'sales:view'],
  demo: ['inventory:demo:view'],
  po: ['purchase-v2:po:view', 'administracion:reportes_pagos'],
};

export const documentsViewGuard: CanActivateFn = (route) => {
  const permissions = inject(PermissionsService);
  const router = inject(Router);
  const type = String(route.paramMap.get('documents_type') || '').trim().toLowerCase();
  const documentId = Number(route.paramMap.get('document_id'));
  const required = DOCUMENT_VIEW_PERMISSIONS[type];

  if (Number.isSafeInteger(documentId) && documentId > 0 && required && permissions.canAny(required)) return true;
  return router.createUrlTree(['/']);
};
